import request from '../utils/request';
import { buildApiPayload } from '../utils/api';

export function getEvents(params, signal) {
  return request({
    url: '/event/events',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endEventTime'] }),
    signal,
  });
}

export function getEventNames() {
  return request({
    url: '/dictionaries/eventName',
    method: 'get',
  });
}

export function getExelExport(params) {
  return request({
    url: '/event/events/xls',
    method: 'get',
    data: buildApiPayload({ payload: params, dateEndKeys: ['endTime'] }),
    responseType: 'arraybuffer',
  });
}
